import { Requirements } from 'app/routes';

import {
    AuctionCampaignCreationStatus,
    MultiCreationAuctionSteps,
    resetMultiCreationFilters,
    setMultiCreationActiveStep,
    setMultiCreationFilters,
    setMultiCreationSelectedVacancyIds,
    setMultiCreationVacancies,
    setMultiCreationVacanciesAuctionInfo,
    setMultiCreationVacanciesSearchValue,
    setNotAvailableForCreationVacancies,
    Vacancy,
    VacancyFilterKeys,
} from 'store/models/multiCreation';

type VacancyFiltersDto = { [key in VacancyFilterKeys]: { id: number; name: string }[] };

const MultiCreationAuctionRequirements: Requirements<{
    vacancies: Vacancy[];
    vacancyFiltersDto: VacancyFiltersDto;
}> = {
    methods: () => ({
        vacancies: { url: '/api/v1/vacancy/active_vacancies', cacheable: false },
        vacancyFiltersDto: { url: '/api/v1/vacancy/active_vacancies/filters', cacheable: false },
    }),
    resolve: ({ result: { vacancies, vacancyFiltersDto } }) => {
        const vacancyFilters = {
            [VacancyFilterKeys.Areas]: vacancyFiltersDto[VacancyFilterKeys.Areas].map(({ id, name }) => ({
                value: String(id),
                text: name,
            })),
            [VacancyFilterKeys.Users]: vacancyFiltersDto[VacancyFilterKeys.Users].map(({ id, name }) => ({
                value: String(id),
                text: name,
            })),
        };

        return [
            setMultiCreationVacancies(
                vacancies.filter(
                    ({ auctionCampaignCreationStatus }) =>
                        auctionCampaignCreationStatus === AuctionCampaignCreationStatus.NotCreated
                )
            ),
            setNotAvailableForCreationVacancies(
                vacancies.filter(
                    ({ auctionCampaignCreationStatus }) =>
                        auctionCampaignCreationStatus !== AuctionCampaignCreationStatus.NotCreated
                )
            ),
            setMultiCreationVacanciesAuctionInfo({
                auctionsToCreate: {},
                vacanciesAuctionInfo: null,
            }),
            setMultiCreationFilters(vacancyFilters),
            setMultiCreationActiveStep(MultiCreationAuctionSteps.VacanciesSelectStep),
            setMultiCreationSelectedVacancyIds({}),
            setMultiCreationVacanciesSearchValue(''),
            resetMultiCreationFilters(null),
        ];
    },
};

export default MultiCreationAuctionRequirements;
